import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import NotFound from './pages/NotFound';
import ScrollToTop, { HomeHashRedirect } from './components/ScrollToTop';
import GoToTop from './components/GoToTop';
import SmoothScroll from './components/motion/SmoothScroll';
import { LocaleProvider } from './context/LocaleContext';
import useScrollReveal from './hooks/useScrollReveal';
import './App.css';

function App() {
  useScrollReveal();

  return (
    <LocaleProvider>
      <Router>
        <SmoothScroll />
        <ScrollToTop />
        <div className="App min-h-screen flex flex-col">
          <Navbar />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/a-propos" element={<HomeHashRedirect sectionId="parcours" />} />
              <Route path="/competences" element={<HomeHashRedirect sectionId="competences" />} />
              <Route path="/projets" element={<HomeHashRedirect sectionId="projets" />} />
              <Route path="/experience" element={<HomeHashRedirect sectionId="parcours" />} />
              <Route path="/contact" element={<HomeHashRedirect sectionId="contact" />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
          <GoToTop />
        </div>
      </Router>
    </LocaleProvider>
  );
}

export default App;
